import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const CircleDownIcon = createIcon(
  'CircleDown',
  <path d="M12,2 C17.52,2 22,6.48 22,12 C22,17.52 17.52,22 12,22 C6.48,22 2,17.52 2,12 C2,6.48 6.48,2 12,2 Z M9.62,10.29 C9.23,9.9 8.6,9.9 8.21,10.29 C7.82,10.68 7.82,11.32 8.21,11.71 L11.29,14.79 C11.69,15.18 12.32,15.18 12.71,14.79 L15.79,11.71 C16.18,11.32 16.18,10.68 15.79,10.29 C15.4,9.9 14.77,9.9 14.38,10.29 L12,12.67 Z" />
);

export default CircleDownIcon;
